import './App.scss';
import { useEffect, useState } from 'react';
import Hero from './Components/Hero';
import About from './Components/About';
import NavBar from './Components/NavBar/';
import Projects from './Components/Projects';
import Separator from './Components/Separator';
import Experience from './Components/Experience';
import { faHeart } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

const MOBILE_WIDTH = 500;
const TABLET_WIDTH = 1000;
const GLOW_COLOR = '#0a484392';
const MOBILE_GLOW_COLOR = '#0c5e57';

const HOVER_OBSERVER_OPTIONS = {
	root: null,
	rootMargin: "-50% 0% -50% 0%",
	threshold: 0
};

const animateGlow = (glowEl: HTMLElement|null) => {
	if (!glowEl) return;

	const deltaX = Math.random() * window.innerWidth - window.innerWidth/2;
	const deltaY = Math.random() * window.innerHeight - window.innerHeight/2;
	
	glowEl.style.backgroundPositionX = deltaX + 'px';
	glowEl.style.backgroundPositionY = deltaY + window.scrollY + 'px';
};

const handleHoverObs = (entries: Array<IntersectionObserverEntry>, observer: IntersectionObserver) => {
	entries.forEach(entry => {
		entry.isIntersecting
			? entry.target.classList.add('-hover')
			: entry.target.classList.remove('-hover');
	});
};


function App() {

	let [glowAnimationID, setGlowAnimationID] = useState<number>(0);
	
	let visibilityObserver: IntersectionObserver | null = null;

	useEffect(() => {
		document.addEventListener('touchstart', e => console.log(e));
		
		const glowEl: HTMLElement|null = document.querySelector('.glow-circle');
		const followMouse = (e: MouseEvent) => {
			if (glowEl) {
				glowEl.style.background = `radial-gradient(100vh at ${e.clientX + window.scrollX}px ${e.clientY + window.scrollY}px, ${GLOW_COLOR}, transparent 50%)`
			}
		};
		
		if (window.innerWidth >= TABLET_WIDTH) {
			clearInterval(glowAnimationID);
			document.addEventListener('mousemove', followMouse);
		}
		else {
			document.removeEventListener('mousemove', followMouse);

			visibilityObserver = new IntersectionObserver(handleHoverObs, HOVER_OBSERVER_OPTIONS);
			document.querySelectorAll('.hoverable').forEach(el => visibilityObserver?.observe(el));

			if (glowEl) {
				let gradienColor = window.innerWidth <= MOBILE_WIDTH ? MOBILE_GLOW_COLOR : GLOW_COLOR;
				glowEl.style.background = `radial-gradient(${Math.min(window.innerHeight, window.innerWidth) - 100}px at ${window.innerWidth/2}px ${window.innerHeight/2}px, ${gradienColor}, transparent 50%) no-repeat`;
				animateGlow(glowEl);
				setGlowAnimationID(window.setInterval(() => animateGlow(glowEl), 5500));
			}
		}

		return () => {
			clearInterval(glowAnimationID);
			visibilityObserver?.disconnect();
			document.removeEventListener('mousemove', followMouse);
		};

	}, []);

	return (
		<div className="body-content-wrapper glow-circle">
			<NavBar/>
			<div className='body-content'>
				<Hero/>
				<div className='sections-container'>
					<About/>
					<Separator isInvisible={true}/>
					<Experience/>
					<Separator isInvisible={true}/>
					<Projects/>
				</div>
			</div>
			<footer className='app-footer'>
				<p>
					Thank you for visiting my personal website. Made with  <FontAwesomeIcon className="icon icon-heart" icon={faHeart} beat/>  using <code className='pill'>React</code>, <code className='pill'>TypeScript</code>, <code className='pill'>SASS</code>, and 
					deployed with <code className='pill'>Vercel</code>. Some design elements inspired
					by <a className='link' target='_blank' rel="noreferrer" href='https://brittanychiang.com/'>Brittany Chiang</a>.
					<br />
					<h5 style={{textAlign: 'right'}}>Last updated: September, 2025</h5>
				</p>
			</footer>
		</div>
	);
} 

export default App;